import { useEffect } from 'react';
import track from 'c9-tracking';
import { Section, Wizard } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { wizardPages } from './config/wizardPagesConfig';
import { DEFAULT_PAGE } from './recoil/types/types';
import CallMeButton from './shared_components/CallMeButton/CallMeButton';
import ShoppingBasketOverlay from './pages/ShoppingBasketOverlay/ShoppingBasketOverlay';
import { TopBar } from './shared_components/TopBar/TopBar';
import useWizardNavigation from './hooks/useWizardNavigation';
import { businessFlowSelector } from './recoil/selectors/getBusinessFlowSelector';
import { resumeOnsaAtom } from './recoil/atoms/resumeOnsaAtom';
import { externalLinks } from './strings';

function App(): React.JSX.Element {
    const { wizardStep, wizardGotoStep } = useWizardNavigation();
    const businessFlow = useRecoilValue(businessFlowSelector);
    const resumeOnsa = useRecoilValue(resumeOnsaAtom);

    useEffect(() => {
        // Track how many times your app is being rendered
        void track.ready(true);
    }, []);

    useEffect(() => {
        if (wizardStep !== DEFAULT_PAGE) return;
        if (businessFlow === 'OPC') {
            wizardGotoStep('OpcEntryPage');
        } else if (businessFlow === 'MPS') {
            wizardGotoStep('MPSActivationPage');
        } else if (businessFlow === 'ONSA') {
            const resumeOnsaAfterLogin = resumeOnsa.jobNumber && resumeOnsa.sessionId;
            const redirectedFromMobileApp =
                new URLSearchParams(window.location.search).get('ref') === 'mobile-insurance-app';
            if (redirectedFromMobileApp) {
                window.location.href = externalLinks.topdanmarkInsurances;
            } else if (resumeOnsaAfterLogin) {
                wizardGotoStep('ResumeOnsaPage');
            } else {
                wizardGotoStep('ProductSelectorPage');
            }
        } else if (businessFlow === 'DA') {
            wizardGotoStep('LandingPage');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (wizardStep === DEFAULT_PAGE) {
        return <></>;
    }

    return (
        <>
            <TopBar />
            <Wizard.Container currentStep={wizardStep}>
                {wizardPages.map((wizardComponent) => {
                    const { name, Component, shouldRemovePadding, shouldShowCallMeButton } =
                        wizardComponent;
                    return (
                        <Wizard.Pane key={name} hideProgress>
                            <>
                                <Section
                                    noSpaceAbove={shouldRemovePadding}
                                    noSpaceBelow={shouldRemovePadding}
                                >
                                    <Component />
                                </Section>
                                {shouldShowCallMeButton && <CallMeButton />}
                            </>
                        </Wizard.Pane>
                    );
                })}
            </Wizard.Container>
            <ShoppingBasketOverlay />
        </>
    );
}

export default App;
